import type { RaceView } from '@ps/isp-web-services-types';
import React from 'react';

import { Vary } from '@swf/components/ResponseHeaders/ResponseHeaders';
import { Header } from '@swf/core/enums';
import { Breadcrumb } from '@swf/sports/components/Breadcrumb/Breadcrumb';

import RaceInfo from '../RaceInfo/RaceInfo';

const RaceWrapper: React.FC<React.PropsWithChildren<{ race: RaceView; races: RaceView[] }>> = ({
  children,
  race,
  races
}) => (
  <>
    <Breadcrumb />
    <Vary by={[Header.TimeZone]} />
    <RaceInfo selectedRace={race} allRaces={races} />
    {children}
  </>
);

export default RaceWrapper;
